module.exports = {"title":"Time's up!","description":"Your order has expired and your transaction has not been completed. Your tickets have been released.<br /><br />Please attempt your order again. You have 10 minutes to complete your order.","close":"Close"}


//////////////////
// WEBPACK FOOTER
// ./src/components/EventListing/TimerUpModal/locales/fr.json
// module id = 1336
// module chunks = 0